// extracted by mini-css-extract-plugin
module.exports = {"container":"big-modal-container_container__1z1Hi","content":"big-modal-container_content__F5yj0","logo":"big-modal-container_logo__WPJg3"};